
import { faPencilSquare, faTimes } from "@fortawesome/free-solid-svg-icons";
import { Button, Container, Stack, Table } from "react-bootstrap"
import Confirm, { ConfirmInfo } from "../confirmComponent/confirm"
import LogoHeader from "../logoHeader/logoHeader"
import { useState } from "react";
import { KundeData } from "./kundeData";
import { HydroSpinner } from "../spinner/hydroSpinner";
import { DataHandler } from "../dataHandler";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ModalAlert from "../sharedComponents/modalAlert";
import { useNavigate } from "react-router-dom";

export default function ListeKunden() {

    const [kData, setKData] = useState<Array<KundeData> | boolean | undefined>();
    const [error, setError] = useState<string | undefined>();
    const [confirmInfo, setConfirmInfo] = useState<ConfirmInfo>();

    const navigate = useNavigate();

    const reload = () => {
        setKData(undefined);
    }

    if (kData === undefined) {
        setKData(true);
        DataHandler.getKundenListe().then((data: Array<KundeData>) => {
            setKData(data);
        }).catch((error) => {
            setKData(false);
            setError(error);
        });
        return (<HydroSpinner />);
    } else if (kData === true)
        return (<HydroSpinner />);
    else if (kData === false)
        return (<Container>
            <LogoHeader />
            <Container>
                <h3>Konnte Daten nicht laden.</h3>
                <Button onClick={reload} variant="primary">Neu laden</Button>
            </Container>
        </Container>)


    const remove = (id: number) => {
        setConfirmInfo({
            text: 'Kunde wirklich löschen?',
            onConfirmCallback: () => {
                DataHandler.deleteKunde(id).then((data: Array<KundeData>) => {
                    setKData(data);
                });
                setConfirmInfo(undefined);
            },
            onAbortCallback: () => {
                setConfirmInfo(undefined);
            }
        })

    }
    const edit = (id: number) => {
        navigate("/kunden/" + id);
    }

    const back = () => {
        navigate("/");
    }

    const createCsv= ()=>{
        DataHandler.createKundenCsv()
    }


    return <Container>
        <Confirm confirmInfo={confirmInfo} />
        {error && <ModalAlert callback={() => setError(undefined)} content={error} contentTitle="Fehler" variant="danger"></ModalAlert>}
        <LogoHeader />
        <Table striped bordered hover size="md">

            <thead>
                <tr>
                    <th>Firmenname</th>
                    <th>Ort</th>
                </tr>
            </thead>
            <tbody>
                {kData.map(data => (
                    <tr className={data.state > 1 ? 'table-light' : 'table-primary'}>
                        <td>{data.json.firmenname}</td>
                        <td>{data.json.ort}</td>
                        <td>
                            <Stack direction="horizontal" gap={1}>
                                <Button onClick={() => { edit(data.id) }} variant="secondary">
                                    <FontAwesomeIcon icon={faPencilSquare} className={"left-icon"} />
                                    &nbsp;Kunde bearbeiten
                                </Button>
                                <Button onClick={() => { remove(data.id) }} variant="danger">
                                    <FontAwesomeIcon icon={faTimes} />
                                    &nbsp; Kunde löschen
                                </Button>
                            </Stack>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
        <Stack direction="horizontal" gap={3}>
            <Button variant="primary" onClick={reload} >Neu laden</Button>
            <Button variant="secondary" onClick={back}>Zurück</Button>
            <Button variant="success" onClick={createCsv}>Kundenexport</Button>
        </Stack>
    </Container>
}